export const types = {
  login: '[Auth] Login',
  logout: '[Auth] Logout',

  uiSetError: '[UI] Set error',
  uiRemoveError: '[UI] Remove error',
  uiStartLoading: '[UI] Start loading',
  uiFinishLoading: '[UI] Finish loading',

  dataLoaded: '[Money] Load data',
  addMovement: '[Money] Add movement',
  updateBalance: '[Money] Update balance',
  moneyLogout: '[Money] Money logout cleaning',
};
